import React, { useEffect, useRef, useState } from 'react';
import styles from './animate-on-value-change.module.scss';

export const AnimateOnValueChange = ({ trigger, children }) => {
    const [animate, setAnimate] = useState(false);
    const firstUpdate = useRef(true);

    useEffect(() => {
        if (firstUpdate.current) {
            // eslint-disable-next-line better-mutation/no-mutation
            firstUpdate.current = false;
            return;
        }
        setAnimate(true);
    }, [trigger]);

    return (
        <span
            className={`d-inline-block ${styles.animateOnValueChange} ${
                animate ? styles.animate : ''
            }`}
            onAnimationEnd={() => setAnimate(false)}>
            {children}
        </span>
    );
};
